import { useEffect, useState } from 'react'
import { getRiskScoresByAssetsLabelled } from 'api'
import {
  Container,
  DataGridTable,
  Blade,
  TypoGraph,
  Divider,
  Chip,
} from 'components'
import moment from 'moment'
import styles from './fleetDetailsForAgent.module.scss'
import strings from 'strings'
import { useGridApiRef } from '@mui/x-data-grid'
import fleetDetailsTableData from './fleetDetailsForAgentTableData'
import { isCarrierLogin } from 'tools/auth'
import { exportTableAsCSV } from 'tools/helper'
import { reportException } from 'tools/logs'

const t = strings.CARRIERS
const e = strings.CSV_EXPORT
interface IFleetDetailsProps {
  print?: boolean
}

const FleetDetailsForAgents: React.FC<IFleetDetailsProps> = (props) => {
  const { print } = props
  const [loading, setLoading] = useState(false)
  const [showAssetDetails, setShowAssetDetails] = useState(false)
  const [selectedRow, setSelectedRow] = useState<any>()
  const [responseData, setResponseData] = useState<any>()
  const [riskAssetData, setRiskAssetData] = useState<any>([])
  const isCarrier = isCarrierLogin()
  const { column, groups } = fleetDetailsTableData(isCarrier)
  const apiRef = useGridApiRef()

  useEffect(() => {
    setLoading(true)
    getRiskScoresByAssetsLabelled(isCarrier)
      .then((res: any) => {
        setResponseData(res)
      })
      .catch((error: any) => {
        reportException(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    if (responseData) {
      setRiskAssetData(responseData.assetsDetails)
    }
  }, [responseData])

  const loadPagination = (pageNumber: number, pageSize: number) => {
    console.log(`pagenumber: ${pageNumber}, pageSize: ${pageSize}`)
  }

  const handleRiskExport = () => {
    const csvString = apiRef.current.getDataAsCsv()
    const csvRows = csvString.split('\n')
    const modifiedCsv = csvRows.slice(1).join('\n')
    exportTableAsCSV(modifiedCsv, e.ASSETS_CSV_EXPORT_NAME)
  }

  const tableMenuItems = [
    {
      label: e.DOWNLOAD_AS_CSV,
      key: 'export',
      action: () => {
        handleRiskExport()
      },
    },
  ]

  const BladeContent = (_props: any) => {
    return (
      <Container className={styles.bladeBodyContainer}>
        <Container className={styles.bladeTabContainer}>

        </Container>
        <Container className={styles.documentsSection}>
          <TypoGraph variant="h6" content="Documents" />
          <Divider />

        </Container>
      </Container>
    )
  }

  const HeaderDom = () => {
    return (
      <Container className={styles.headerContainer}>
        <Container className={styles.headerTitleContainer}>
          <TypoGraph
            variant="h1"
            sx={{ marginRight: '1rem' }}
            mb={0}
            content={localStorage.getItem('carrierName') ?? localStorage.getItem('companyName') ?? 'Carrier Details'}
          />
          <Chip
            label={`Updated ${moment().format('dddd, MMMM Do')}`}
            variant="filled"
            sx={{
              backgroundColor: '#E1FAEB',
              color: '#20693D',
            }}
          />
        </Container>
      </Container>
    )
  }

  return (
    <Container className={styles.agentsBladeBodyContainer}>
      <Container>
        {/* Asset Activity & Scoring */}
        <DataGridTable
          apiRef={apiRef}
          title={'Asset Activity & Scoring'}
          loading={loading}
          data={riskAssetData || []}
          columns={column}
          columnGroupingModel={groups}
          columnHeaderHeight={30}
          columnVisibilityModel={{ assetId: false }}
          totalCount={riskAssetData?.length}
          reduceHeight={342}
          checkboxSelection={false}
          multiSearchFilter={false}
          sortField={'totalMiles'}
          sortOrder={'desc'}
          getRowId={(row: any) => row?.assetId + "-" + row?.score}
          handlePagination={(pageNumber, pageSize) =>
            loadPagination(pageNumber, pageSize)
          }
          menuList={tableMenuItems}
        />
        <Blade
          title={selectedRow?.assetEldId}
          open={showAssetDetails}
          onClose={() => setShowAssetDetails(false)}
          bodyNode={<BladeContent />}
        />
      </Container>
    </Container>
  )
}

export default FleetDetailsForAgents